<template>
  <v-row>
    <v-dialog
      v-model="modalitenerary"
      width="600"
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-card-title class=" primary text-truncate">
          <v-btn
            icon
            dark
            @click="modalitenerary = false"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
          <span>
            Get Data Service {{ indexdate }}
          </span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-text-field
            v-model="recorditinerary.time"
            label="Time"
            dense
            type="time"
            outlined
          ></v-text-field>
          <v-select
            v-model="recorditinerary.category"
            dense
            :items="['Activity','Restaurant','Entrance','Transport']"
            outlined
            placeholder="Category"
            label="Category"
            @change="OpenService()"
          ></v-select>
          <v-text-field
            v-model="recorditinerary.description"
            readonly
            dense
            solo
            placeholder="Description"
            label="Description"
            outlines
          />
          <v-currency-field
            v-model="recorditinerary.total"
            prefix="Rp."
            readonly
            dense
            placeholder="Total"
            label="Total"
            disabbled
          />

          <v-btn
            block
            small
            color="primary"
            @click="SaveDetailItinerary()"
          >
            Add
            <v-icon>{{ icons.mdiPlus }}</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog3"
      width="1000"
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      @click:outside="CekDialog()"
    >
      <v-card>
        <v-card-title class="text-h5 primary text-truncate">
          <v-btn
            icon
            dark
            @click="CekDialog()"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>

          <span
            v-if="status_edit"
            style="max-width: 90%;"
            class="text-truncate"
          >Edit Perhitungan {{ recordedit.category }} {{ recordedit.description }}</span>
          <span
            v-else
            style="max-width: 90%;"
            class="text-truncate"
          >Proses Perhitungan {{ recorditinerary.description }}</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row>
            <v-col v-if="status_edit">
              <ProsesHitung
                v-if="dialog3"
                :datahitung="recordedit"
              >
              </ProsesHitung>
            </v-col>
            <v-col v-else>
              <ProsesHitung
                v-if="dialog3"
                :datahitung="recorditinerary"
              >
              </ProsesHitung>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog2"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5 primary">
          <v-btn
            icon
            dark
            @click="dialog2 = false"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>  Choose {{ recorditinerary.category }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row>
            <v-col v-if="recorditinerary.category == 'Activity'">
              <GetActivity></GetActivity>
            </v-col>
            <v-col v-if="recorditinerary.category == 'Restaurant'">
              <GetRestaurant></GetRestaurant>
            </v-col>
            <v-col v-if="recorditinerary.category == 'Entrance'">
              <GetEntrance></GetEntrance>
            </v-col>
            <v-col v-if="recorditinerary.category == 'Transport'">
              <GetTransport></GetTransport>
            </v-col>
            <v-col v-if="recorditinerary.category == 'Hotel'">
              <GetHotel :date="datend"></GetHotel>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog2 = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-col
      cols="12"
    >
      <v-simple-table>
        <thead>
          <tr>
            <td width="15%">
              Time
            </td>
            <td>
              Category
            </td>
            <td>
              Description
            </td>
            <td>
              Total
            </td>
            <td width="7%">
              Action
            </td>
          </tr>
        </thead>
        <tbody
          v-for="(item, index) in itinerary.data"
          :key="index"
        >
          <tr class="primary">
            <td>
              <span class=" white--text">Day {{ index+1 }}, {{ item.date }}
              </span>
            </td>
            <td colspan="3">
              <v-text-field
                v-model="itinerary.data[index].package_name"
                dense
                solo
                placeholder="Package name"
                hide-details
                label="Package Name"
                outlines
                @change="CekPackageName(index)"
              />
            </td>
            <td>
              <v-btn
                block
                small
                color="success"
                @click="AddIndex(index)"
              >
                Add Itinerari
                <v-icon>{{ icons.mdiPlus }}</v-icon>
              </v-btn>
            </td>
          </tr>
          <template v-if="( itinerary.data[index].details.length >0)">
            <tr
              v-for="(dt, indexd) in itinerary.data[index].details "
              :key="dt.time"
            >
              <td>
                <v-text-field
                  v-model="itinerary.data[index].details[indexd].time"
                  label="Time"
                  hide-details=""
                  dense
                  type="time"
                  outlined
                ></v-text-field>
              </td>
              <td>{{ dt.category }}</td>
              <td>{{ dt.description }}</td>
              <td> Rp. {{ Number(dt.total).toLocaleString() }}</td>
              <td>
                <v-btn
                  small
                  dense
                  class="error"
                  @click="DeleteItinerary(index,indexd)"
                >
                  <v-icon>{{ icons.mdiTrashCan }}</v-icon>
                </v-btn>
                <v-btn
                  small
                  dense
                  class="primary ml-1"
                  @click="ViewDetailItinerary(index,indexd)"
                >
                  <v-icon>{{ icons.mdiPencil }}</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                class="text-center"
                colspan="5"
              >
                No Activity
              </td>
            </tr>
          </template>
        </tbody>
        <tfoot>
          <tr class="font-weight-bold">
            <td colspan="4">
              Total Itinerary
            </td>
            <td>
              Rp. {{ Number(itinerary.grandtotalitinerary).toLocaleString() }}
            </td>
          </tr>
        </tfoot>
      </v-simple-table>
    </v-col>
  </v-row>
</template>
<script>
import moment from 'moment'
import axios from 'axios'

import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
  mdiEye,
} from '@mdi/js'
import GetActivity from '../get-data/get-activity.vue'
import GetTransport from '../get-data/get-transport.vue'
import GetRestaurant from '../get-data/get-restaurant.vue'
import GetHotel from '../get-data/get-hotel.vue'
import ProsesHitung from './ProsesHitung.vue'
import GetEntrance from '../get-data/get-entrance.vue'

export default {
  components: {
    GetActivity,
    GetTransport,
    GetRestaurant,
    GetHotel,
    ProsesHitung,
    GetEntrance,
  },
  props: ['datainvoice'],
  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
        mdiEye,
      },
      indexinput: 0,
      dialog2: false,
      dialog3: false,
      add: true,
      endtime: '',
      time: '12:00',
      menu2: false,
      modal2: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      modalitenerary: false,
      datend: '',
      invoice: [],
      itinerary: {
        grandtotalitinerary: 0,
        data: [],
      },
      recorditinerary: {
        id_service: '',
        detail: this.datainvoice,
        time: '',
        category: '',
        description: '',
        cost_for_adult: 0,
        cost_for_child: 0,
        cost: 0,
        qty_adult: 0,
        qty_child: 0,
        qty: 0,
        markup_adult: 0,
        markup_child: 0,
        markup: 0,
        total_adult: 0,
        total_child: 0,
        total: 0,
        perpax_adult: 0,
        perpax_child: 0,
        perpax: 0,
        grand_total: 0,
      },
      recordedit: {
        detail: this.datainvoice,
        time: '',
        category: '',
        description: '',
        cost_for_adult: 0,
        cost_for_child: 0,
        cost: 0,
        qty_adult: 0,
        qty_child: 0,
        qty: 1,
        markup_adult: 0,
        markup_child: 0,
        markup: 0,
        total_adult: 0,
        total_child: 0,
        total: 0,
        perpax_adult: 0,
        perpax_child: 0,
        perpax: 0,
        grand_total: 0,
      },
      status_edit: false,
      indexdata: '',
      indexdate: '',
      indexdetails: '',
      statusindex: true,
    }
  },
  mounted() {
    this.datend = this.datainvoice.travel_date
    this.$root.$on('MakeItinerary', (data, type) => {
      this.AddItinerary(data, type)
      this.dialog2 = false
    })
    this.$root.$on('HitungItinerary', (data, type) => {
      this.AddItinerary(data, type)
      this.dialog2 = false
      this.dialog3 = false
      this.CountCostItinerary()
    })
  },
  created() {

  },
  methods: {
    CekPackageName(index) {
      if (!this.itinerary.data[index].package_name) {
        this.$root.$emit('PesanResponse', 'Please Input Package Name', 'red')
        this.itinerary.data[index].package_name = '-'
      }
    },
    UpdateData() {
      if (this.$route.query.id_tour) {
        this.getDataEditTour()
      }
      this.ChooseDateItinerary()
    },
    getDataEditTour() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/getDataEditItinerari', { id_tour: this.$route.query.id_tour }).then(response => {
        if (response.data.data.length > 0) {
          this.itinerary.data = response.data.data
          this.$root.$emit('CountPerpax')
        } else {
          this.ChooseDateItinerary()
        }
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
      }).catch(err => {
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
        this.isLoading = false
      })
    },
    AddIndex(index) {
      this.indexinput = index
      this.indexdate = this.itinerary.data[index].date
      this.modalitenerary = true
    },
    CekDialog() {
      this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.recorditinerary = {
        detail: this.datainvoice,
        time: '',
        category: '',
        description: '',
        cost_for_adult: 0,
        cost_for_child: 0,
        cost: 0,
        qty_adult: 0,
        qty_child: 0,
        qty: 0,
        markup_adult: 0,
        markup_child: 0,
        markup: 0,
        total_adult: 0,
        total_child: 0,
        total: 0,
        perpax_adult: 0,
        perpax_child: 0,
        perpax: 0,
        grand_total: 0,
      }
      this.dialog3 = false
      this.CountCostItinerary()
    },
    ViewDetailItinerary(index, indexd) {
      this.status_edit = true
      this.indexdata = index
      this.indexdetails = indexd
      this.recordedit = this.itinerary.data[index].details[indexd]
      this.dialog3 = true
    },
    CountCostItinerary() {
      let grandtotala = 0
      this.itinerary.data.forEach(number => {
        let grandtotalb = 0
        number.details.forEach(data => {
          // eslint-disable-next-line no-const-assign, radix
          grandtotalb += parseInt(data.total)
        })
        // eslint-disable-next-line no-const-assign, radix
        grandtotala += parseInt(grandtotalb)
        // eslint-disable-next-line no-const-assign
      //  grandtotal += number.total
      })
      this.itinerary.grandtotalitinerary = grandtotala
      this.$root.$emit('MakeInvoice', this.itinerary, 'travelitinerary')
    },

    DeleteItinerary(indexdata, indexdetails) {
      this.$delete(this.itinerary.data[indexdata].details, indexdetails)
      if (this.itinerary.data[indexdata].details.length < 1) {
        //     this.$delete(this.itinerary.data, indexdata)
      }
      this.CountCostItinerary()
    },
    ChangeTotal() {
      if (this.recorditinerary.qty < 1 || this.recorditinerary.markup < 0) {
        this.recorditinerary.qty = 1
        this.recorditinerary.markup = 0
        // eslint-disable-next-line radix
        this.recorditinerary.total = parseInt(this.recorditinerary.cost) * parseInt(this.recorditinerary.qty) + parseInt(this.recorditinerary.markup)
        this.$root.$emit('PesanResponse', 'Minimal Qty 1 Dan Markup adalah 0', 'red')
      } else {
        // eslint-disable-next-line radix
        this.recorditinerary.total = parseInt(this.recorditinerary.cost) * parseInt(this.recorditinerary.qty) + parseInt(this.recorditinerary.markup)
      }
      this.CountCostItinerary()
    },
    ChangeTotalInput(index, indexd) {
      if (this.itinerary.data[index].details[indexd].qty < 1 || this.itinerary.data[index].details[indexd].markup < 0) {
        this.itinerary.data[index].details[indexd].qty = 1
        this.itinerary.data[index].details[indexd].markup = 0
        // eslint-disable-next-line radix
        this.itinerary.data[index].details[indexd].total = parseInt(this.itinerary.data[index].details[indexd].cost) * parseInt(this.itinerary.data[index].details[indexd].qty) + parseInt(this.itinerary.data[index].details[indexd].markup)
        this.$root.$emit('PesanResponse', 'Minimal Qty 1 Dan Markup adalah 0', 'red')
      } else {
        // eslint-disable-next-line radix
        this.itinerary.data[index].details[indexd].total = parseInt(this.itinerary.data[index].details[indexd].cost) * parseInt(this.itinerary.data[index].details[indexd].qty) + parseInt(this.itinerary.data[index].details[indexd].markup)
      }
      this.CountCostItinerary()
    },
    AddItinerary(data, type) {
      if (type === 'Activity') {
        this.recorditinerary.description = `${data.company_name} For ${data.service_name} ${data.detail_activity}  `
        this.recorditinerary.cost_for_adult = data.cost_for_adult
        this.recorditinerary.cost_for_child = data.cost_for_child
        this.recorditinerary.id_service = data.id_service_activity
        this.recorditinerary.id_activity = data.id_activity
        // eslint-disable-next-line radix
        this.recorditinerary.cost = parseInt(data.cost_for_adult) + parseInt(data.cost_for_child)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_adult = 0
        // eslint-disable-next-line radix
        this.recorditinerary.qty_adult_awal = parseInt(this.datainvoice.total_adult)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_child_awal = parseInt(this.datainvoice.total_cnb) + parseInt(this.datainvoice.total_cwb)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_child = 0
        // eslint-disable-next-line radix
        this.recorditinerary.qty = 0
        this.recorditinerary.markup_adult = 0
        this.recorditinerary.markup_child = 0
        this.recorditinerary.markup = 0
        this.recorditinerary.total_child = data.cost_for_child
        this.recorditinerary.total_adult = data.cost_for_adult
        this.recorditinerary.total = 0
        this.recorditinerary.perpax_adult = 0
        this.recorditinerary.perpax_child = 0
        this.recorditinerary.perpax = 0
        this.dialog3 = true
      }

      if (type === 'Restaurant') {
        this.recorditinerary.description = `${data.restaurant_name} - ${data.service_name} ${data.detail_service} `
        this.recorditinerary.cost_for_adult = data.cost_for_adult
        this.recorditinerary.id_activity = data.id_restaurant
        this.recorditinerary.id_service = data.id_service_restaurant
        this.recorditinerary.cost_for_child = data.cost_for_child
        // eslint-disable-next-line radix
        this.recorditinerary.cost = parseInt(data.cost_for_adult) + parseInt(data.cost_for_child)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_adult = 0
        // eslint-disable-next-line radix
        this.recorditinerary.qty_adult_awal = parseInt(this.datainvoice.total_adult)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_child_awal = parseInt(this.datainvoice.total_cnb) + parseInt(this.datainvoice.total_cwb)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_child = 0
        // eslint-disable-next-line radix
        this.recorditinerary.qty = 0
        this.recorditinerary.markup_adult = 0
        this.recorditinerary.markup_child = 0
        this.recorditinerary.markup = 0
        this.recorditinerary.total_child = data.cost_for_child
        this.recorditinerary.total_adult = data.cost_for_adult
        this.recorditinerary.total = 0
        this.recorditinerary.perpax_adult = 0
        this.recorditinerary.perpax_child = 0
        this.recorditinerary.perpax = 0
        this.dialog3 = true
      }

      if (type === 'Entrance') {
        this.recorditinerary.description = `${data.entrance_name} - ${data.note}`
        this.recorditinerary.cost_for_adult = data.rate_for_adult
        this.recorditinerary.cost_for_child = data.rate_for_child
        this.recorditinerary.id_service = data.id_entrance
        this.recorditinerary.id_activity = data.id_entrance
        // eslint-disable-next-line radix
        this.recorditinerary.cost = parseInt(data.rate_for_adult) + parseInt(data.rate_for_child)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_adult = 0
        // eslint-disable-next-line radix
        this.recorditinerary.qty_adult_awal = parseInt(this.datainvoice.total_adult)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_child_awal = parseInt(this.datainvoice.total_cnb) + parseInt(this.datainvoice.total_cwb)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_child = 0
        // eslint-disable-next-line radix
        this.recorditinerary.qty = 0
        this.recorditinerary.markup_adult = 0
        this.recorditinerary.markup_child = 0
        this.recorditinerary.markup = 0
        this.recorditinerary.total_child = data.rate_for_child
        this.recorditinerary.total_adult = data.rate_for_adult
        this.recorditinerary.total = 0
        this.recorditinerary.perpax_adult = 0
        this.recorditinerary.perpax_child = 0
        this.recorditinerary.perpax = 0
        this.dialog3 = true
      }

      if (type === 'Transport') {
        this.recorditinerary.description = ` Menggunakan ${data.type_car} Rute ${data.service_name}  `
        this.recorditinerary.cost_for_adult = data.cost
        this.recorditinerary.id_service = data.id_service_transport
        this.recorditinerary.id_activity = data.id_transport
        this.recorditinerary.cost_for_child = 0
        // eslint-disable-next-line radix
        this.recorditinerary.cost = parseInt(data.cost)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_adult = 0
        // eslint-disable-next-line radix
        this.recorditinerary.qty_adult_awal = parseInt(this.datainvoice.total_adult)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_child_awal = parseInt(this.datainvoice.total_cnb) + parseInt(this.datainvoice.total_cwb)
        // eslint-disable-next-line radix
        this.recorditinerary.qty_child = 0
        // eslint-disable-next-line radix
        this.recorditinerary.qty = 0
        this.recorditinerary.markup_adult = 0
        this.recorditinerary.markup_child = 0
        this.recorditinerary.markup = 0
        this.recorditinerary.total_child = 0
        this.recorditinerary.total_adult = data.cost
        this.recorditinerary.total = 0
        this.recorditinerary.perpax_adult = 0
        this.recorditinerary.perpax_child = 0
        this.recorditinerary.perpax = 0
        this.dialog3 = true
      }
    },
    OpenService() {
      this.status_edit = false
      this.dialog2 = true
    },
    SaveDetailItinerary() {
      if (!this.recorditinerary.category) {
        this.$root.$emit('PesanResponse', 'Please Choose Category', 'red')
      } else {
        if (this.status_edit) {
          this.itinerary.data[this.indexdata].details[this.indexdetails] = this.recorditinerary
          this.recordedit = []
          this.status_edit = false
          this.CekDialog()
        } else {
          this.itinerary.data[this.indexinput].details.push(this.recorditinerary)
          this.CekDialog()
        }
        this.status_edit = false
        this.add = true
        this.CountCostItinerary()
      }
    },
    SimpanTime(time) {
      this.recorditinerary.time = time
      this.endtime = time
      this.modal2 = false
    },
    AddDay() {
      this.modalitenerary = true
    },

    ChooseDateItinerary() {
      if (this.itinerary.data.length < 0) {
        const a = moment(this.datainvoice.travel_date)
        const b = moment(this.datainvoice.end_travel_date)

        // If you want an exclusive end date (half-open interval)
        for (let m = moment(a); m.diff(b, 'days') <= 0; m.add(1, 'days')) {
          this.itinerary.data.push({
            package_name: '-',
            date: m.format('YYYY-MM-DD'),
            details: [],
          })
        }
      } else {
        this.itinerary.data = []

        const a = moment(this.datainvoice.travel_date)
        const b = moment(this.datainvoice.end_travel_date)

        // If you want an exclusive end date (half-open interval)
        for (let m = moment(a); m.diff(b, 'days') <= 0; m.add(1, 'days')) {
          this.itinerary.data.push({
            package_name: '-',
            date: m.format('YYYY-MM-DD'),
            details: [],
          })
        }
      }

      /* this.itinerary.data.push({
        date: dat,
        details: [],
      }) */
    },

  },
}
</script>
